import React from 'react'
import Note from 'plaid-threads/Note'

import './plaid-endpoint.scss';

const Endpoint = props => {
  return (
    <>
      <div className={'plaid-endpoint-container'}>
        <Note className={'plaid-post'}>
          POST
        </Note>
        <div className={'plaid-endpoint-contents'}>
          <div className={'plaid-endpoint-header'}>
            {props.name != null && (
              <span className={'plaid-endpoint-name'}>{props.name}</span>
            )}
            <span className={'plaid-schema'}>{props.schema}</span>
          </div>
          <div className={'plaid-endpoint-description'}>{props.description}</div>
        </div>
      </div>
    </>
  )
}

Endpoint.displayName = 'Endpoint'

export default Endpoint
